import Vue from 'vue'
import axios from 'axios'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage);

const state = {
    cgaStatus: Vue.localStorage.get('cgaStatus') || false,
    cgaPatient: null,
    cgaPatientSheet: null,
    cgaPatientSheets: [],
    totalPatientSheets: []
};

const getters = {
    cgaStatus(state) {
        return state.cgaStatus;
    },
    cgaPatient(state) {
        return state.cgaPatient;
    },
    cgaPatientSheet(state) {
        return state.cgaPatientSheet;
    },
    cgaPatientSheets(state) {
        return state.cgaPatientSheets;
    },
    cgaSheetById: (state) => (id) => {
        return state.cgaPatientSheets.filter(sh => sh.id === id)[0];
    }
};

const mutations = {
    SET_CGA_STATUS(state, active) {
        state.cgaStatus = active;
    },
    SET_CGA_PATIENT(state, patient) {
        state.cgaPatient = patient;
    },
    SET_PATIENT_SHEETS(state, sheets) {
        state.cgaPatientSheets = sheets;
    },
    SET_PATIENT_SHEET(state, sheet) {
        state.cgaPatientSheet = sheet;
    },
    SET_PATIENT_SHEET_NAME(state, name) {
        state.cgaPatientSheet.name = name;
    },
    SET_PATIENT_SHEET_WEIGHT(state, weight) {
        state.cgaPatientSheet.weight = weight;
    },
    SET_PATIENT_SHEET_RESULT(state, result) {
        state.cgaPatientSheet.tests.find(obj => {
            return obj.id == result.id;
        }).result = result.value;
    },
    SET_PATIENT_SHEET_REMARKS(state, remarks) {
        state.cgaPatientSheet.tests.find(obj => {
            return obj.id == remarks.id;
        }).remarks = remarks.value;
    },
    SET_SHEET_ACTIVE_STATUS(state, sheet) {
        state.cgaPatientSheets.find(obj => {
            return obj.id == sheet.id;
        }).isActive = sheet.isActive;
    }
};

const actions = {
    commitPatientSheetChanges(context) {
        return new Promise((resolve, reject) => {
            axios.put("/api/patients/" + context.getters.cgaPatient.id + "/active-sheet", context.getters.cgaPatientSheet)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    loadPatientSheet(context, patientId) {
        return new Promise((resolve, reject) => {
            axios.get("/api/patients/" + patientId + "/active-sheet")
                .then(response => {
                    context.commit("SET_PATIENT_SHEET", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    applyActiveSheet(context, sheets) {
        let activeSheet = sheets.find(obj => {
            return obj.isActive === true;
        });
        context.commit("SET_PATIENT_SHEET", activeSheet);
    },
    activateCga(context, patient) {
        return context.dispatch("loadPatientSheets", patient.id).then(response => {
                context.commit("SET_CGA_PATIENT", patient);
                Vue.localStorage.set('cgaPatientId', patient.id);
                context.commit("SET_CGA_STATUS", true);
                Vue.localStorage.set('cgaStatus', true);
                context.dispatch('selectLanguage', patient.language);
            })
            .catch(error => {
                console.log(error);
            });
    },
    deactivateCga(context) {
        context.commit("SET_CGA_PATIENT", null);
        Vue.localStorage.remove('cgaPatientId');
        context.commit("SET_CGA_STATUS", false);
        Vue.localStorage.remove('cgaStatus');
        context.commit("SET_PATIENT_SHEET", null);
        context.commit("SET_PATIENT_SHEETS", null);
    },
    loadPatient(context) {
        return new Promise((resolve, reject) => {
            if (Vue.localStorage.get('cgaPatientId') != null && context.getters.cgaPatient == null) {
                axios.get("/api/patients/" + Vue.localStorage.get('cgaPatientId'))
                    .then(response => {
                        context.dispatch('activateCga', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } else {
                // reject();
            }
        });

    },
    loadPatientSheets(context, patientId) {
        return new Promise((resolve, reject) => {
            axios.get('/api/patients/' + patientId + '/sheets')
                .then(response => {
                    context.commit("SET_PATIENT_SHEETS", response.data);
                    context.dispatch("applyActiveSheet", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    activateSheet(context, sheetId) {
        return new Promise((resolve, reject) => {
            axios.put('/api/patients/' + context.getters.cgaPatient.id + '/sheets/activate', {
                    sheetId: sheetId
                })
                .then(response => {
                    context.dispatch("changeActiveSheet", sheetId);
                    resolve(response);
                })
                .catch(error => {
                    reject();
                });
        });
    },
    changeActiveSheet(context, sheetId) {
        context.getters.cgaPatientSheets.forEach(sheet => {
            if (sheet.id == sheetId) {
                context.commit("SET_SHEET_ACTIVE_STATUS", {
                    id: sheet.id,
                    isActive: true
                });
            } else {
                context.commit("SET_SHEET_ACTIVE_STATUS", {
                    id: sheet.id,
                    isActive: false
                });
            }
        });

        context.dispatch("applyActiveSheet", context.getters.cgaPatientSheets);
    },
    createSheet(context, sheet) {
        return new Promise((resolve, reject) => {
            axios.post('/api/patients/' + context.getters.cgaPatient.id + '/sheets/create', {
                    name: sheet.name,
                    weight: sheet.weight
                })
                .then(response => {
                    Promise.all([context.dispatch("loadPatientSheets", context.getters.cgaPatient.id)])
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

    }
};

export default {
    state,
    getters,
    mutations,
    actions
};